export default "__VITE_ASSET__CvU4n4zp__"